import { Component, ComponentInterface, Element, h, Host, JSX, Listen, Prop } from '@stencil/core';
import { SharedDirectionService } from '../../global/init-services';
import { LinkVariant, LinkSize } from './link.types';

/**
 * Text links should take the user to a new place or change the view of the page the user is seeing. The structure of
 * links depends on the context and their purpose.
 *
 * @slot - Text content of the link
 * @slot icon - Optional wb-icon element
 * @slot trail-icon - Optional wb-icon element
 */
@Component({
  tag: 'wb-link',
  styleUrl: 'link.scss',
  shadow: true,
})
export class LinkComponent implements ComponentInterface {
  @Element()
  public el: HTMLElement;

  /** Link variant (inline links inherit typography from parent) */
  @Prop({ reflect: true })
  public variant!: LinkVariant;

  /** Link size */
  @Prop({ reflect: true })
  public size: LinkSize = 'l';

  /** Passed through to internal `<a>` */
  @Prop()
  public href: string;

  /** Passed through to internal `<a>` */
  @Prop()
  public download: any;

  /** Passed through to internal `<a>` */
  @Prop()
  public referrerPolicy: ReferrerPolicy;

  /** Passed through to internal `<a>` */
  @Prop()
  public rel: string;

  /** Passed through to internal `<a>` */
  @Prop()
  public target: string;

  /** @internal */
  @Prop({ reflect: true, mutable: true })
  public isRtl: boolean = false;

  public connectedCallback(): void {
    this.updateDirection();
  }

  @Listen('wbdirchange', { target: 'document' })
  public updateDirection() {
    this.isRtl = SharedDirectionService.isRtl;
  }

  public render(): JSX.Element {
    return (
      <Host class="wb-link">
        <a href={this.href} download={this.download} referrerPolicy={this.referrerPolicy} rel={this.rel} target={this.target}>
          <slot name="icon" />
          <slot />
          <slot name="trail-icon" />
        </a>
      </Host>
    );
  }
}
